import './VoiceActivityDebug.css';

/**
 * Painel de debug para visualizar estado do useVoiceActivity
 * @param {Object} props
 * @param {Object} props.voiceState - Estado retornado do useVoiceActivity { state, duration, rms }
 */
export default function VoiceActivityDebug({ voiceState }) {
  if (!voiceState) return null;

  const { state, duration, rms } = voiceState;

  // Cores baseadas no estado
  const getStateColor = () => {
    switch (state) {
      case 'silent':
        return '#666';
      case 'noise':
        return '#FFA500';
      case 'speaking':
        return '#4CAF50';
      default:
        return '#666';
    }
  };

  // Ícone baseado no estado
  const getStateIcon = () => {
    switch (state) {
      case 'silent':
        return '🔇';
      case 'noise':
        return '📢';
      case 'speaking':
        return '🎤';
      default:
        return '❓';
    }
  };

  // Barra de volume visual
  const volumePercent = Math.min(Math.round(rms * 100), 100);

  return (
    <div className="voice-activity-debug">
      <div className="voice-debug-header">
        <span className="voice-debug-title">🎙️ Voice Activity</span>
      </div>

      <div className="voice-debug-content">
        {/* Estado atual */}
        <div className="voice-debug-row">
          <span className="voice-debug-label">Estado:</span>
          <span
            className="voice-debug-value voice-state-badge"
            style={{ backgroundColor: getStateColor() }}
          >
            {getStateIcon()} {state.toUpperCase()}
          </span>
        </div>

        {/* Duração no estado */}
        <div className="voice-debug-row">
          <span className="voice-debug-label">Duração:</span>
          <span className="voice-debug-value">
            {(duration / 1000).toFixed(2)}s
          </span>
        </div>

        {/* RMS (volume) */}
        <div className="voice-debug-row">
          <span className="voice-debug-label">Volume (RMS):</span>
          <span className="voice-debug-value">
            {(rms * 100).toFixed(1)}%
          </span>
        </div>

        {/* Barra de volume visual */}
        <div className="voice-volume-bar-container">
          <div
            className="voice-volume-bar"
            style={{
              width: `${volumePercent}%`,
              backgroundColor: getStateColor()
            }}
          />
        </div>

        {/* Thresholds de referência */}
        <div className="voice-thresholds">
          <div className="voice-threshold-item">
            <span className="voice-threshold-dot" style={{ backgroundColor: '#666' }} />
            <span className="voice-threshold-text">Silent: &lt; 1%</span>
          </div>
          <div className="voice-threshold-item">
            <span className="voice-threshold-dot" style={{ backgroundColor: '#FFA500' }} />
            <span className="voice-threshold-text">Noise: 1-5%</span>
          </div>
          <div className="voice-threshold-item">
            <span className="voice-threshold-dot" style={{ backgroundColor: '#4CAF50' }} />
            <span className="voice-threshold-text">Speaking: &gt; 5%</span>
          </div>
        </div>
      </div>
    </div>
  );
}

